module.exports = __webpack_public_path__ + "img/cooperationContentImg5.da507ef3.png";